import { Analytics } from "@vercel/analytics/react";
import { Banner } from "./Banner";
import GameContainer from "./GameContainer";
import "./styles.css";

/**
 * Every game lives at its own route. Dash and Blitz are static exports that
 * Vercel rewrites to directly; this app only renders the menu and Bufo.
 *
 *   /dash   Bonfire Dash (Godot web export served statically from public/dash)
 *   /bufo   Bufo Bonfire (the PixiJS game in this app)
 *   /blitz  Bonfire Blitz (Godot web export served statically from public/blitz)
 *
 * `/bufo?screensaver` renders the Bufo scene without a player or banner.
 */
function normalizePath(pathname: string): string {
  const trimmed = pathname.replace(/\/+$/, "");
  return trimmed === "" ? "/" : trimmed;
}

function Menu() {
  return (
    <main className="main">
      <a href="/dash" className="start-button bonfiredash">
        <span className="dash-title">Bonfire Dash</span>
        <span className="new-badge">NEW!</span>
      </a>
      <div className="game-options">
        <a href="/bufo" className="start-button bufobonfire">
          Bufo Bonfire
        </a>
        <a href="/blitz" className="start-button bonfireblitz">
          Bonfire Blitz
        </a>
      </div>
    </main>
  );
}

function Page() {
  const params = new URLSearchParams(window.location.search);
  const path = normalizePath(window.location.pathname);

  switch (path) {
    case "/bufo":
      if (params.has("screensaver")) {
        return <GameContainer screensaver={true} />;
      }

      return (
        <>
          <Banner />
          <GameContainer />
        </>
      );

    case "/":
    default:
      return <Menu />;
  }
}

export default function App() {
  return (
    <>
      <Page />
      <Analytics />
    </>
  );
}
